import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default class ImageGalleryController extends React.Component {
    constructor(props) {
        super(props);

        this.state = { current: 0, enlarged: false };
        this.timeout = null;
    }

    componentDidMount() {
        this.autoRotate();
    }

    onSelect(index) {
        this.setState({ current: index });
    }

    onNext() {
        this.setState({ current: this.state.current < this.props.images.length - 1 ? this.state.current + 1 : 0 });
        this.autoRotate();
    }

    onPrev() {
        this.setState({ current: this.state.current > 0 ? this.state.current - 1 : this.props.images.length - 1 });
        this.autoRotate();
    }

    onToggleEnlarge() {
        this.setState({ enlarged: !this.state.enlarged });
    }

    autoRotate() {
        if (this.props.autoRotate) {
            if (this.timeout !== null) clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.onNext();
            }, this.props.autoRotate * 1000);
        }
    }

    render() {
        const ImageGalleryView = ComponentRegistry.get(this.props.view);

        return (
          <ImageGalleryView
            {...this.props}
            enlarged={this.state.enlarged}
            current={this.props.images[this.state.current]}
            onNext={() => this.onNext()}
            onPrev={() => this.onPrev()}
            onSelect={index => this.onSelect(index)}
            onToggleEnlarge={() => this.onToggleEnlarge()}
          >{this.props.images}</ImageGalleryView>
        );
    }
}

ImageGalleryController.propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    view: PropTypes.string.isRequired,
    autoRotate: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
};

ImageGalleryController.defaultProps = {
    view: "ImageGalleryViewsImageGalleryView",
    autoRotate: false,
};



// WEBPACK FOOTER //
// ./src-js/Fratello/ImageGallery/Controllers/ImageGalleryController.jsx